export default __webpack_public_path__ + "static/iphone PRO-strategy-manager-dba13545af055599e4392153440ed4c6.png";